module.exports = __webpack_public_path__ + "Pages-icon.0fd5f549d439c281557b.woff";


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.woff?-u69vo5
// module id = ../../../../../src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.woff?-u69vo5
// module chunks = styles